// extracted by mini-css-extract-plugin
export var box = "_8q-1";
export var checked = "_8q-2";
export var descriptionSpacer = "_8q-9";
export var disabled = "_8q-3";
export var icon = "_8q-6";
export var input = "_8q-0";
export var labelSpacer = "_8q-8";
export var medium = "_8q-5";
export var small = "_8q-4";
export var text = "_8q-7";